import { useState, useEffect } from "react";
import { getDomain, getFormUrlEncoded } from "../helpers/helpers";
import AuthRightPanelImage from "./AuthRightPanelPage";
import { useLocation, useNavigate } from "react-router-dom";
import LoginForm from "./LoginForm";
const Login = () => {

  const [showGraphic, setShowGraphic] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  // Auth check on mount
  useEffect(() => {
    setIsLoading(false);
  }, [navigate]);

  // Handle OAuth redirect
  useEffect(() => {
    redirectToAuthorize();
  }, [location.search, location.pathname]);

  function redirectToAuthorize() {
    const domainObject = getDomain(); // e.g., { domain: "http://localhost:3000" }
    const redirectHost = `${getDomain().domain}/login`; // update env names for CRA

    const searchParams = new URLSearchParams(location.search);
    const clientIdParams = searchParams.get("client_id");
    const redirectUriParams = searchParams.get("redirect_uri");
    const responseType = searchParams.get("response_type");
    const grantType = searchParams.get("grant_type");
    const state = searchParams.get("state");

    const redirectUri = `${domainObject.domain}/authorize`;

    const clientId = process.env.REACT_APP_CLIENT_ID;

    if (!redirectHost || !redirectUri || !clientId) {
      console.error("Missing env config:", {
        redirectHost,
        redirectUri,
        clientId,
      });
      return;
    }

    try {
      const currentHost = window.location.origin;
      const targetHost = new URL(redirectHost, currentHost).origin;
      if (
        currentHost === targetHost &&
        location.pathname.includes("/login") &&
        !!redirectUriParams &&
        !!clientIdParams &&
        !!responseType &&
        !!grantType &&
        !!state
      ) {
        console.warn("Already on login host; not redirecting to self.");
        return;
      }
    } catch (err) {
      // ignore
    }

    const query = getFormUrlEncoded({
      client_id: clientId,
      response_type: "code",
      grant_type: "authorization_code",
      state: "someState", // TODO: generate secure CSRF state
      redirect_uri: redirectUri,
    });

    const externalUrl = `${redirectHost.replace(/\/$/, "")}/?${query}`;
    window.location.replace(externalUrl);
  }

  useEffect(() => {
    function update() {
      setShowGraphic(window.innerWidth >= 768);
    }
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  if (isLoading) {
    return null; // prevent flash
  }


  return (
    <div className="flex h-screen">
      <div className="w-full md:w-1/2 flex items-center justify-center p-8">
        <LoginForm />
      </div>

      {showGraphic && (
        <AuthRightPanelImage />
      )}
    </div>
  );
};

export default Login;
